import api from "../../../utils/api";
import { regroupThreadsByDate } from "../../../components/SideBar/cache/caching";

const DRAFT_BOT_PREFIX = "draft-bot-";

export const getDraftThreadId = (botId) => `${DRAFT_BOT_PREFIX}${botId}`;

export const isDraftThreadId = (threadId) =>
  typeof threadId === "string" && threadId.startsWith(DRAFT_BOT_PREFIX);

export const getDraftBotId = (threadId) =>
  isDraftThreadId(threadId)
    ? Number(threadId.slice(DRAFT_BOT_PREFIX.length))
    : null;

const DEFAULT_THREAD_NAMES = [
  "New Chat",
  "New Thread",
  "EC Thread",
  "Invoicing Thread",
];

const isThreadEmpty = async (token, threadId) => {
  try {
    const response = await api.get(
      `/v2/responses-chat/conversation/${threadId}/history`,
      {
        headers: { Authorization: `Bearer ${token}` },
      },
    );
    return !Array.isArray(response.data) || response.data.length === 0;
  } catch (error) {
    console.error("Error checking thread history:", error);
    return false;
  }
};

export const deleteEmptyDefaultThreads = async (token, conversations = []) => {
  const candidates = conversations.filter((item) =>
    DEFAULT_THREAD_NAMES.includes(item?.name),
  );

  const survivors = [...conversations];
  const deletedIds = [];

  for (const candidate of candidates) {
    const empty = await isThreadEmpty(token, candidate.thread_id);
    if (!empty) continue;

    try {
      await api.delete(
        `/v2/responses-chat/conversation/${candidate.thread_id}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      );

      const index = survivors.findIndex(
        (item) => item.thread_id === candidate.thread_id,
      );
      if (index !== -1) survivors.splice(index, 1);
      deletedIds.push(candidate.thread_id?.toString());
      localStorage.removeItem(`messages_${candidate.thread_id}`);
    } catch (error) {
      console.error("Error deleting empty thread:", error);
    }
  }

  return { survivors, deletedIds };
};

export const startDraftBotSession = ({
  botId,
  title = "New Chat",
  setThread,
  setThreadId,
  setBotRole,
  setMessages,
  setNewMessage,
  setHistory,
  setSidebarVisible,
}) => {
  const draftId = getDraftThreadId(botId);

  setThread(null);
  setThreadId(draftId);
  setBotRole("responses_api");
  setMessages([]);
  setNewMessage?.("");
  if (window.innerWidth < 640) setSidebarVisible?.(false);

  setHistory((prevHistory) => {
    const allItems = Object.values(prevHistory || {})
      .flat()
      .filter(Boolean);
    const filtered = allItems.filter((item) => item.thread_id !== draftId);
    const timestamp = new Date().toISOString();
    const draftItem = {
      id: draftId,
      thread_id: draftId,
      name: title,
      updated_at: timestamp,
      last_used: timestamp,
      thread: null,
      bot_role: "responses_api",
      bot_id: botId,
    };

    return regroupThreadsByDate([draftItem, ...filtered]);
  });
};
